import axios from '@/util/axios'
import { API_RELAY_PATH } from '@/util/constants'
import store from '@/store'

/**
 * 検索条件追加API
 * @param  {} params={}
 */
export const add = (params = {}) => {
  const defaults = {
    _path: 'SC/001',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 検索条件一覧API
 * @param  {} params={}
 */
export const list = (params = {}) => {
  const defaults = {
    _path: 'SC/002',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 検索条件一覧件数取得API
 * @param  {} params={}
 */
export const count = (params = {}) => {
  const defaults = {
    _path: 'SC/003',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 検索条件更新API
 * @param  {} params={}
 */
export const update = (params = {}) => {
  const defaults = {
    _path: 'SC/004',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}

/**
 * 検索条件削除API
 * @param  {} params={}
 */
export const remove = (params = {}) => {
  const defaults = {
    _path: 'SC/005',
    token: store.state.auth.token
  }

  const r = { ...defaults, ...params }

  return axios.post(API_RELAY_PATH, r)
}
